export default {
  event_comparison_table_first_column: '事件名称',
  event_comparison_table_second_column: '周期',
};
